import React from "react";
import { useLocation } from "react-router";
import AuthManager from "../Common/AuthManager";
import { buildHelpUrl, hasWorkspaceAccess } from "../Common/HelpUrl";

const PUBLIC_PATHS = [
  "/",
  "/login",
  "/logout",
  "/callback/login",
  // Retired 2026-07-30 — the /landing/dashboard route is commented out in App.tsx, so this
  // allowlist entry can never match. Kept alongside the route for a one-revert restore.
  // "/landing/dashboard",
];

const WorkspaceInitGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  const isPublic = PUBLIC_PATHS.includes(location.pathname);
  const isAuthed = AuthManager.isAuthenticated();

  if (!isPublic && isAuthed && !hasWorkspaceAccess()) {
    window.location.href = buildHelpUrl();
    return null;
  }

  return <>{children}</>;
};

export default WorkspaceInitGate;
